module.exports = __webpack_public_path__ + "img/ic_faq.2a5964f6.svg";